import { OP } from "../../constant";

// get all api by admin
export function fetchAllApiRequest(token, data) {
  return {
    type: OP.API_LIST_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function fetchAllApiReset() {
  return {
    type: OP.API_LIST_RESET,
  };
}

// get api details
export function apiDetailsRequest(token, data) {
  return {
    type: OP.API_DETAILS_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function apiDetailsReset() {
  return {
    type: OP.API_DETAILS_RESET,
  };
}

// view api
export function viewApiRequest(token, data) {
  return {
    type: OP.VIEW_API_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function viewApiReset() {
  return {
    type: OP.VIEW_API_RESET,
  };
}

// activate api
export function activateApiRequest(token, data) {
  return {
    type: OP.ACTIVATE_API_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function activateApiReset() {
  return {
    type: OP.ACTIVATE_API_RESET,
  };
}

// deactivate api
export function deactivateApiRequest(token, data) {
  return {
    type: OP.DEACTIVATE_API_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function deactivateApiReset() {
  return {
    type: OP.DEACTIVATE_API_RESET,
  };
}

// approve Api
export function approveApiRequest(token, data) {
  return {
    type: OP.APPROVE_API_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function approveApiReset() {
  return {
    type: OP.APPROVE_API_RESET,
  };
}

// reject Api
export function rejectApiRequest(token, data) {
  return {
    type: OP.REJECT_API_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function rejectApiReset() {
  return {
    type: OP.REJECT_API_RESET,
  };
}

// get partner properties
export function getPartnerPropertiesRequest(token, data) {
  return {
    type: OP.GET_PARTNER_PROPERTIES_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function getPartnerPropertiesReset() {
  return {
    type: OP.GET_PARTNER_PROPERTIES_RESET,
  };
}

// create partner property
export function createPartnerPropertyRequest(token, data) {
  return {
    type: OP.CREATE_PARTNER_PROPERTY_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function createPartnerPropertyReset() {
  return {
    type: OP.CREATE_PARTNER_PROPERTY_RESET,
  };
}

// update partner property
export function updatePartnerPropertyRequest(token, data) {
  return {
    type: OP.UPDATE_PARTNER_PROPERTY_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function updatePartnerPropertyReset() {
  return {
    type: OP.UPDATE_PARTNER_PROPERTY_RESET,
  };
}

// update fsp code
export function updateFspCodeRequest(token, data) {
  return {
    type: OP.UPDATE_FSP_CODE_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function updateFspCodeReset() {
  return {
    type: OP.UPDATE_FSP_CODE_RESET,
  };
}

// update outbound credentials
export function updateOutboundCredentialsRequest(token, data) {
  return {
    type: OP.UPDATE_OUTBOUND_CREDENTIALS_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function updateOutboundCredentialsReset() {
  return {
    type: OP.UPDATE_OUTBOUND_CREDENTIALS_RESET,
  };
}

// download key
export function downloadKeyRequest(token, data) {
  return {
    type: OP.DOWNLOAD_KEY_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function downloadKeyReset() {
  return {
    type: OP.DOWNLOAD_KEY_RESET,
  };
}
